import { HStack, VStack, Text } from '@chakra-ui/react';
import { useBalance } from '@thirdweb-dev/react';
import React, { FC, useCallback, useMemo } from 'react';

import { DebouncedInput } from '@app/components/DebouncedInput';
import { TokenSelector } from '@app/components/Swap/components/TokenSelector';
import { formatCurrency } from '@app/helpers/formatCurrency';
import { Token } from '@app/types/token';

interface Props {
  label: string;
  handleTokenSelection: (token: Token) => void;
  handleValueChange: (value: string) => void;
  value: string;
  token: Token | null;
}

export const AmountInput: FC<Props> = ({
  handleValueChange,
  value,
  label,
  handleTokenSelection,
  token
}) => {
  const { data: balance, isLoading } = useBalance(token?.contractAddress);

  const balanceString = useMemo(() => {
    if (isLoading || !balance) return 'Loading...';

    return formatCurrency.format(Number(balance.displayValue));
  }, [balance, isLoading]);

  const handleInput = useCallback(
    (value: string) => {
      if (value === '.') value = '0.';

      handleValueChange(value);
    },
    [handleValueChange]
  );

  return (
    <VStack
      w="100%"
      bg="neutral.1000"
      transition="background 0.2s ease"
      px="16px"
      py="12px"
      borderRadius="12px"
      overflow="hidden"
    >
      <Text
        textAlign="left"
        w="100%"
        color="neutral.300"
        fontSize="12px"
        lineHeight="18px"
        letterSpacing="-0.18px"
      >
        {label}
      </Text>
      <HStack w="100%">
        <TokenSelector
          onSelect={val => {
            handleTokenSelection(val);
          }}
          disabled
          selected={token}
          isV3
        />
        <DebouncedInput
          amount={value}
          disabled={false}
          onChange={handleInput}
          // readOnlyValue={readOnlyValue}
        />
      </HStack>
      <HStack w="100%" justify="space-between">
        <HStack justify="flex-start">
          <Text
            color="neutral.500"
            fontSize="12px"
            fontWeight="400"
            lineHeight="18px"
            letterSpacing="-0.18px"
          >
            Balance:
          </Text>
          <Text
            color="neutral.400"
            fontSize="12px"
            fontWeight="400"
            lineHeight="18px"
            letterSpacing="-0.18px"
          >
            {token && balanceString ? balanceString : 'n/a'}
          </Text>
        </HStack>
        {/*<Text*/}
        {/*  color="neutral.400"*/}
        {/*  fontSize="12px"*/}
        {/*  fontWeight="400"*/}
        {/*  lineHeight="18px"*/}
        {/*  letterSpacing="-0.18px"*/}
        {/*>*/}
        {/*  {(fiatValue && formatUSD.format(fiatValue)) ?? '$0'}*/}
        {/*</Text>*/}
      </HStack>
    </VStack>
  );
};
